import {showLoading, hideLoading} from './loading';
import {handleAPI} from './common';

export {showLoading, hideLoading, handleAPI};



// WEBPACK FOOTER //
// ./src/js/fetch/index.js